export default __webpack_public_path__ + "static/media/AcceleronsGallery_44.fedd67e4.webp";